const rankings = [
  { rank: 1, title: '某顶流男星深夜密会神秘女子', heat: '980万', tag: '爆', tagColor: 'bg-primary-500 text-background-50' },
  { rank: 2, title: '年度热门综艺决赛名单提前泄露', heat: '860万', tag: '热', tagColor: 'bg-accent-500 text-background-50' },
  { rank: 3, title: '当红小花新剧片场路透曝光', heat: '750万', tag: '热', tagColor: 'bg-accent-500 text-background-50' },
  { rank: 4, title: '知名导演宣布新作演员阵容', heat: '620万', tag: '新', tagColor: 'bg-secondary-500 text-background-50' },
  { rank: 5, title: '网红情侣疑似分手引发全网讨论', heat: '580万', tag: '议', tagColor: 'bg-secondary-400 text-background-50' },
  { rank: 6, title: '某品牌代言人更换引粉丝争议', heat: '490万', tag: '议', tagColor: 'bg-secondary-400 text-background-50' },
  { rank: 7, title: '热门IP改编剧确认主创团队', heat: '420万', tag: '新', tagColor: 'bg-secondary-500 text-background-50' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">吃瓜热榜</h2>
            <p className="text-sm text-foreground-500 mt-1">实时热度排行，最受关注的吃瓜话题</p>
          </div>
          <span className="text-xs text-foreground-400 bg-background-100 px-3 py-1 rounded-full whitespace-nowrap">更新于 10分钟前</span>
        </div>

        <div className="bg-background-100 rounded-2xl overflow-hidden">
          {rankings.map((item, i) => (
            <a
              key={item.rank}
              href="#carousel"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#carousel');
                if (el) {
                  const top = el.getBoundingClientRect().top + window.scrollY - 80;
                  window.scrollTo({ top, behavior: 'smooth' });
                }
              }}
              className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-background-200/60 transition-colors ${
                i < rankings.length - 1 ? 'border-b border-secondary-200/40' : ''
              }`}
            >
              <span className={`w-7 h-7 rounded-lg flex items-center justify-center text-sm font-bold whitespace-nowrap flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-secondary-200 text-foreground-600'
              }`}>
                {item.rank}
              </span>
              <span className="flex-1 text-sm md:text-base text-foreground-800 font-medium truncate">{item.title}</span>
              <span className={`text-xs px-1.5 py-0.5 rounded whitespace-nowrap flex-shrink-0 ${item.tagColor}`}>{item.tag}</span>
              <span className="text-xs text-foreground-400 whitespace-nowrap flex-shrink-0 w-16 text-right">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}